//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Table, TableColumn } from 'element-ui'

export default {
  components: {
    ElTable: Table,
    tableColumn: TableColumn,
  },

  props: {
    list: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    tableColumnWidths() {
      const combination = `${Number(this.filter.includes('price'))}${Number(
        this.filter.includes('employeesPrice')
      )}`
      const widths = {
        '00': { goodsTitle: 299 },
        '01': { goodsTitle: 219 },
        10: { goodsTitle: 150, price: 149 },
        11: { goodsTitle: 110, price: 109 },
      }

      return widths[combination]
    },
  },
}
